export default __webpack_public_path__ + "static/media/draw_cross.381cdbbe.svg";